import React, { useState } from 'react';
import { DmsButton, intl } from 'dmsbasereact';
import { DmsReturnModal } from '../DmsReturnModal/DmsReturnModal';
import AddIcon from '@mui/icons-material/Add';

export const DmsCreateReturnButton = ({ table }) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <DmsButton
                variant="primary"
                text={intl.get("AddReturn").d("Add Return")}
                icon={<AddIcon />}
                onClick={() => setModalOpen(true)}
            />
            {modalOpen && (
                <DmsReturnModal
                    show={modalOpen}
                    onHide={() => setModalOpen(false)}
                    table={table}
                />
            )}
        </>
    );
};
